import { useOneSignal } from '@/hooks/useOneSignal';

/** Mounts the OneSignal Web SDK and syncs the signed-in user's external_id. */
const OneSignalInit = () => {
  useOneSignal();
  return null;
};

export default OneSignalInit;
